import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Loader extends Component {
  render() {
    const {show, customStyleBg} = this.props;
    if (show){
      return (
        <div className="loader-bg" style={{...customStyleBg}}>
          <div className="loader-content">
            <div className="spinner">
              <img alt="logo" src={require('assets/img/logo.png')}/>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}

Loader.propTypes = {
  show: PropTypes.bool
};

export default Loader;
